import i18n from "../../i18n/i18n";

export const formatNumber = (
    value: number,
    decimals: number = 2,
    addDots: boolean = true
): string => {
    if (value === null || value === undefined || isNaN(value)) {
        return '';
    }

    let formattedValue = value.toFixed(decimals);

    if (addDots) {
        const parts = formattedValue.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        formattedValue = parts.join(',');
    } else {
        formattedValue = formattedValue.replace('.', ',');
    }

    return formattedValue;
};

export const convertToNumber = (value: any): number => {
    if (value === null || value === undefined) {
        return 0;
    }

    if (typeof value === 'number') {
        return value;
    }

    if (typeof value === 'string') {
        if (value === '') {
            return 0;
        }
        const convertedValue = parseFloat(value.replace(/\./g, '').replace(',', '.'));
        return isNaN(convertedValue) ? 0 : convertedValue;
    }

    return 0;
};

export const capitalizeWords = (str: string): string => {
    return str
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

export const getDateFormat = (type: string) => {
    const isTurkish = i18n.language === 'tr';

    switch (type) {
        case 'week':
            return isTurkish ? 'YYYY – [Hafta] wo' : 'YYYY – [Week] wo';
        case 'month':
            return isTurkish ? 'YYYY – MMMM' : 'YYYY – MMMM';
        case 'year':
            return 'YYYY';
        default:
            return 'YYYY-MM-DD';
    }
};